
import React from "react";

const KeyFeaturesSection = () => {
  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 md:mb-6">
            Key <span className="text-[#8932c8]">Features</span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Spharaka XDR combines advanced detection, investigation, and response capabilities into a unified platform powered by Agentic AI.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          <div className="bg-white p-5 md:p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-lg md:text-xl font-semibold mb-2">Comprehensive Protection</h3>
            <p className="text-sm md:text-base text-gray-600">
              Unified security across endpoints, networks, cloud workloads, and applications with a single integrated platform.
            </p>
          </div>

          <div className="bg-white p-5 md:p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-lg md:text-xl font-semibold mb-2">Agentic AI</h3>
            <p className="text-sm md:text-base text-gray-600">
              True autonomous security powered by contextually-aware AI that can make decisions and take actions with minimal human intervention.
            </p>
          </div>

          <div className="bg-white p-5 md:p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-lg md:text-xl font-semibold mb-2">Automated Response</h3>
            <p className="text-sm md:text-base text-gray-600">
              Instantly contain threats with automated response actions that stop attacks in their tracks before damage occurs.
            </p>
          </div>

          <div className="bg-white p-5 md:p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-lg md:text-xl font-semibold mb-2">Advanced Analytics</h3>
            <p className="text-sm md:text-base text-gray-600">
              Uncover hidden threats with behavioral analytics and machine learning that detect anomalies traditional tools miss.
            </p>
          </div>

          <div className="bg-white p-5 md:p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-lg md:text-xl font-semibold mb-2">Threat Intelligence</h3>
            <p className="text-sm md:text-base text-gray-600">
              Built-in threat intelligence with continuous updates to protect against the latest attack techniques and vulnerabilities.
            </p>
          </div>

          <div className="bg-white p-5 md:p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-lg md:text-xl font-semibold mb-2">Simplified Operations</h3>
            <p className="text-sm md:text-base text-gray-600">
              Intuitive interface designed for both security experts and IT generalists, reducing complexity and operational burden.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyFeaturesSection;
